import { lazy } from "react";
import Loadable from "app/components/Loadable";
import Amortizations from "../Amortizations";


const AmortizationsRoute = [{ path: "/Amortizations", element: <Amortizations /> }];
export default AmortizationsRoute;